export const TEXT_404 = `
        ,--,                      ,--, 
      ,--.'|    ,----..         ,--.'| 
   ,--,  | :   /   /   \\     ,--,  | : 
,---.'|  : '  /   .     : ,---.'|  : ' 
;   : |  | ; .   /   ;.  \\;   : |  | ; 
|   | : _' |.   ;   /  \` ;|   | : _' | 
:   : |.'  |;   |  ; \\ ; |:   : |.'  | 
|   ' '  ; :|   :  | ; | '|   ' '  ; : 
\\   \\  .'. |.   |  ' ' ' :\\   \\  .'. | 
 \`---\`:  | ''   ;  \\; /  | \`---\`:  | ' 
      '  ; | \\   \\  ',  /       '  ; | 
      |  : ;  ;   :    /        |  : ; 
      '  ,/    \\   \\ .'         '  ,/  
      '--'      \`---\`           '--'   

`;

export const TEXT_500 = `
       ,----,.                             
     ,'   ,' |                             
   ,'   .'   |    ,----..       ,----..    
 ,----.'    .'   /   /   \\     /   /   \\   
 |    |   .'    /   .     :   /   .     :  
 :    :  |--,  .   /   ;.  \\ .   /   ;.  \\ 
 :    |  ;.' \\.   ;   /  \` ;.   ;   /  \` ; 
 |    |      |;   |  ; \\ ; |;   |  ; \\ ; | 
 \`----'.'\\   ;|   :  | ; | '|   :  | ; | ' 
   __  \\  .  |.   |  ' ' ' :.   |  ' ' ' : 
 /   /\\/  /  :'   ;  \\; /  |'   ;  \\; /  | 
/ ,,/  ',-   . \\   \\  ',  /  \\   \\  ',  /  
\\ ''\\       ;   ;   :    /    ;   :    /   
 \\   \\    .'     \\   \\ .'      \\   \\ .'    
  \`--\`-,-'        \`---\`         \`---\`      
                                           
`;
